import React from 'react'
import { Link } from 'gatsby'

function TopBrands() {
  return (
    <div className="spacing-large">
      <div className="brands text-small">
        <Link to="/brands" className="brands-img-link" aria-label="See the brands that trust us">
          <img src="/images/brands/apple.svg" title="Apple" alt="Apple" loading="lazy" />
          <img src="/images/brands/google.svg" title="Google" alt="Google" loading="lazy" />
          <img src="/images/brands/adobe.svg" title="Adobe" alt="Adobe" loading="lazy" />
          <img src="/images/brands/hp.svg" title="HP" alt="HP" loading="lazy" />
          <img src="/images/brands/netflix.svg" title="Netflix" alt="Netflix" loading="lazy" />
          <img
            src="/images/brands/microsoft.svg"
            title="Microsoft"
            alt="Microsoft"
            loading="lazy"
          />
          <img
            src="/images/brands/starbucks.svg"
            title="Starbucks"
            alt="Starbucks"
            loading="lazy"
          />
          <img src="/images/brands/paypal.svg" title="PayPal" alt="PayPal" loading="lazy" />
          <img src="/images/brands/slack.svg" title="Slack" alt="Slack" loading="lazy" />
          <img src="/images/brands/walmart.svg" title="Walmart" alt="Walmart" loading="lazy" />
          <img src="/images/brands/github.svg" title="Github" alt="GitHub" loading="lazy" />
          <img src="/images/brands/pixar.svg" title="Pixar" alt="Pixar" loading="lazy" />
          <img src="/images/brands/mozilla.svg" title="Mozilla" alt="Mozilla" loading="lazy" />
          <img
            src="/images/brands/code-cademy.svg"
            title="Code Cademy"
            alt="Code Cademy"
            loading="lazy"
          />
          <img src="/images/brands/uber.svg" title="Uber" alt="Uber" loading="lazy" />
          <img src="/images/brands/verizon.svg" title="Verizon" alt="Verizon" loading="lazy" />
          <img src="/images/brands/airbnb.svg" title="Airbnb" alt="Airbnb" loading="lazy" />
          <img src="/images/brands/indeed.svg" title="Indeed" alt="Indeed" loading="lazy" />
          <img src="/images/brands/lego.svg" title="Lego" alt="Lego" loading="lazy" />
          <img
            src="/images/brands/the-washington-post.svg"
            title="The Washington Post"
            alt="The Washington Post"
            loading="lazy"
          />
        </Link>
      </div>
      <div className="align-center text-small">
        <Link to="/brands">Trusted by these brands and more</Link>
      </div>
    </div>
  )
}

export default TopBrands
